module.exports = __webpack_public_path__ + "img/SKWINKELNetActieKPI5FA7C4.451158f5.png";